export const SET_CHANNELS = 'SET_CHANNELS'
export const SET_PRICE_LEVEL_DEFAULT_VALUE = 'SET_PRICE_LEVEL_DEFAULT_VALUE'
export const SET = 'SET'
export const FETCHED = 'FETCHED'

